import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyConfirmationModalModule } from '@vendasta/galaxy/confirmation-modal';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';

export interface CancelOrderDialogData {
  isAdmin: boolean;
}

@Component({
  templateUrl: './decline-cancellation-dialog.component.html',
  styleUrl: './decline-cancellation-dialog.component.scss',
  imports: [
    GalaxyConfirmationModalModule,
    CommonModule,
    MatButtonModule,
    MatIconModule,
    GalaxyFormFieldModule,
    GalaxyBadgeModule,
    FormsModule,
    TranslateModule,
  ],
})
export class DeclineCancellationDialogComponent {
  notes: string;

  private dialogRef = inject(MatDialogRef<DeclineCancellationDialogComponent>);

  onCancel(): void {
    this.dialogRef.close(this.notes);
  }

  onDontCancel(): void {
    this.dialogRef.close();
  }
}
